import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApplicationConfigService } from '../../core/config/application-config.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private baseUrl: string;

  constructor(
    private http: HttpClient,
    private applicationConfigService: ApplicationConfigService
  ) {
    this.baseUrl = this.applicationConfigService.getEndpointFor('api');
  }

  /** Send OTP for forgot password */
  sendOtp(email: string): Observable<string> {
    return this.http.post(
      `${this.baseUrl}/login/send-otp`,
      { email },
      { headers: this.jsonHeaders(), responseType: 'text' }
    ).pipe(catchError(this.handleError.bind(this)));
  }

  /** Verify OTP for forgot password (isForgetPassword = true) */
  verifyOtp(email: string, otp: string): Observable<any> {
    const params = new HttpParams().set('isForgetPassword', 'true');
    return this.http.post<any>(
      `${this.baseUrl}/login/verify-otp`,
      { email, otp },
      { headers: this.jsonHeaders(), params }
    ).pipe(catchError(this.handleError.bind(this)));
  }

  /** Reset password after OTP verification */
  resetPassword(userName: string, password: string): Observable<string> {
    return this.http.post(
      `${this.baseUrl}/login/resetPassword`,
      { userName, password },
      { headers: this.jsonHeaders(), responseType: 'text' }
    ).pipe(catchError(this.handleError.bind(this)));
  }

  private jsonHeaders(): HttpHeaders {
    return new HttpHeaders({ 'Content-Type': 'application/json' });
  }

  private handleError(error: any): Observable<never> {
    let message = 'Server error occurred';
    if (typeof error?.error === 'string' && error.error.trim()) {
      try {
        const parsed = JSON.parse(error.error);
        message = parsed.message || parsed.error || error.error;
      } catch (e) {
        message = error.error;
      }
    } else if (error?.error?.message) {
      message = error.error.message;
    } else if (error?.error?.error) {
      message = error.error.error;
    } else if (error?.message) {
      message = error.message;
    } else if (error?.statusText && error.statusText !== 'OK') {
      message = error.statusText;
    }
    console.error('ForgotPasswordService Error:', message, error);
    return throwError(() => error);
  }
}
